/**
 * Cash Action Creators
 */
import { Kushki } from "@kushki/js";
import { CashTokenRequest } from "@kushki/js/lib/types/cash_token_request";
import { ErrorResponse } from "@kushki/js/lib/types/error_response";
import { setErrorMessage } from "components/Error/store/Actions";
import {
  hideOverlay,
  showOverlay,
} from "components/OverLay/store/ActionCreators";
import { Actions } from "containers/Cash/store/Actions";
import { ThunkAction, ThunkDispatch } from "redux-thunk";
import { CurrencyEnum } from "root/shared/CurrencyEnum";
import {
  CajitaStore,
  ICashFormProps,
  IInputProps,
} from "root/store/CajitaStore";
import { updateDisableButton } from "root/store/Reducer";
import { ICashActionCreator } from "types/cash_action_creator";
import { TokenResponse } from "types/remote/token_response";

function getStatusValidity(state: ICashFormProps, currency: string): boolean {
  let isValid: boolean = true;
  let inputs: string[];

  if (currency === CurrencyEnum.MXN)
    inputs = ["nameInput", "lastNameInput", "email"];
  else inputs = ["nameInput", "lastNameInput", "identificationInput", "email"];

  for (const inputName of inputs) {
    if (state[inputName].rules.required)
      isValid =
        state[inputName].valid && isValid && state[inputName].value !== "";
    if (!state[inputName].rules.required && state[inputName].value !== "")
      isValid = state[inputName].valid && isValid;
  }

  return isValid;
}

const inputAction: (payload: IInputProps) => ICashActionCreator = (
  payload: IInputProps
): ICashActionCreator => ({
  type: Actions.UPDATE_CASH_INPUT,
  input: payload,
});

const disableCashAction: () => ICashActionCreator = (): ICashActionCreator => ({
  type: Actions.DISABLE_CASH_FORM,
});

const changeStatus: () => ICashActionCreator = (): ICashActionCreator => ({
  type: Actions.SWITCH_CASH_VALIDITY,
});

const setDirty: (payload: IInputProps) => ICashActionCreator = (
  payload: IInputProps
): ICashActionCreator => ({
  type: Actions.SET_CASH_INPUT_DIRTY,
  input: payload,
});

const updateCashToken: (payload: string) => ICashActionCreator = (
  payload: string
): ICashActionCreator => ({
  type: Actions.SET_CASH_TOKEN,
  token: payload,
});

function updateInput(
  payload: IInputProps
): ThunkAction<void, CajitaStore, undefined, ICashActionCreator> {
  return (
    dispatch: ThunkDispatch<CajitaStore, undefined, ICashActionCreator>,
    getState: () => CajitaStore
  ): void => {
    dispatch(inputAction(payload));
    const state: ICashFormProps = getState().cash;
    const currency: string = getState().config.currency;
    const status: boolean = getStatusValidity(state, currency);

    if (state.isValid !== status) dispatch(changeStatus());
  };
}

function getCashToken(
  body: CashTokenRequest
): ThunkAction<void, CajitaStore, undefined, ICashActionCreator> {
  return (dispatch: Function, getState: () => CajitaStore): void => {
    const kushki: Kushki = getState().config.kushkiJS as Kushki;

    dispatch(updateDisableButton(true));
    dispatch(showOverlay());
    kushki.requestCashToken(body, (response: TokenResponse | ErrorResponse) => {
      if ("token" in response) dispatch(updateCashToken(response.token));
      else {
        dispatch(setErrorMessage(response.message));
        dispatch(hideOverlay());
      }
      dispatch(updateDisableButton(false));
    });
  };
}

function updateCashDocumentType(
  documentType: string
): ThunkAction<void, CajitaStore, undefined, ICashActionCreator> {
  return (
    dispatch: ThunkDispatch<CajitaStore, undefined, ICashActionCreator>,
    _getState: () => CajitaStore
  ): void => {
    const updateDocumentType: ICashActionCreator = {
      type: Actions.UPDATE_DOCUMENT_TYPE_NUMBER,
      token: documentType,
    };

    dispatch(updateDocumentType);
  };
}

export {
  setDirty,
  updateInput,
  getCashToken,
  changeStatus,
  disableCashAction,
  updateCashDocumentType,
};



// WEBPACK FOOTER //
// ./src/containers/Cash/store/ActionCreators.tsx